import { ActiveTabTypeEnum } from '@routes/Common/type';
import { useLocation } from 'react-router-dom';

const useActiveTab = () => {
  const { pathname } = useLocation();
  if (pathname.includes(ActiveTabTypeEnum.DASHBOARD)) {
    return ActiveTabTypeEnum.DASHBOARD;
  }
  if (pathname.includes(ActiveTabTypeEnum.CHAT)) {
    return ActiveTabTypeEnum.CHAT;
  }

  if (pathname.includes(ActiveTabTypeEnum.PAYMENT)) {
    return ActiveTabTypeEnum.PAYMENT;
  }
  return false;
};

export { useActiveTab };
